var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuleDraft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rule--draft_svg__clip0_61530_7401)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.28 14.47l-2.25-2.25a.75.75 0 00-1.06 0L12 19.19v3.31h3.31l6.97-6.97a.75.75 0 000-1.06zM14.69 21H13.5v-1.19l3.75-3.75 1.19 1.19L14.69 21zm4.81-4.81L18.31 15l1.19-1.19L20.69 15l-1.19 1.19zM13.5 12H6v1.5h7.5V12zM15 7.5H6V9h9V7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3A1.502 1.502 0 0018 1.5H3A1.502 1.502 0 001.5 3v9.75a8.236 8.236 0 004.368 7.28L9.75 22.1v-1.7l-3.176-1.693A6.74 6.74 0 013 12.75V3h15v6.75h1.5V3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rule--draft_svg__clip0_61530_7401"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgRuleDraft;